module.exports = __webpack_public_path__ + "static/media/title-mobile-china.4ab8bd6a.png";